<script>
import { mapActions } from "vuex";

export default {
  name: "SoilProfileMixin",
  computed: {},
  methods: {
    ...mapActions("soilProfile", {
      setNestedParameter: "setNestedParameter",
    }),
    setXParameter(index, value, item) {
      let newIndex = 0;
      for (let i = 0; i < this.soilProfileBlock.length; i++) {
        if (this.soilProfileBlock[i]["x"] >= value && i !== index) {
          newIndex = i;
          break;
        }
        if (i === this.soilProfileBlock.length - 1) {
          newIndex = i;
        }
      }

      if (newIndex === index || this.soilProfileBlock[newIndex - 1] === item) {
        this.setNestedParameter({
          value: value,
          item: item,
          parameter: "x",
        });
      } else {
        if (this.soilProfileBlock[index - 1] && this.soilProfileBlock[index + 1]) {
          this.setNestedParameter({
            value: this.soilProfileBlock[index - 1]["x_end"],
            item: this.soilProfileBlock[index + 1],
            parameter: "x_start",
          });
        } else if (this.soilProfileBlock[index - 1]) {
          this.setNestedParameter({
            value: null,
            item: this.soilProfileBlock[index - 1],
            parameter: "x_end",
          });
        } else if (this.soilProfileBlock[index + 1]) {
          this.setNestedParameter({
            value: null,
            item: this.soilProfileBlock[index + 1],
            parameter: "x_start",
          });
        }

        this.setNestedParameter({
          value: value,
          item: item,
          parameter: "x",
        });
        this.setNestedParameter({
          value: value,
          item: item,
          parameter: "x_start",
        });
        this.setNestedParameter({
          value: value,
          item: item,
          parameter: "x_end",
        });

        newIndex = this.soilProfileBlock.findIndex((profile) => item === profile);

        if (newIndex === 0 && this.soilProfileBlock[1]) {
          this.setNestedParameter({
            value: null,
            item: item,
            parameter: "x_start",
          });
          this.setNestedParameter({
            value: value,
            item: this.soilProfileBlock[1],
            parameter: "x_start",
          });
        } else if (
          newIndex === this.soilProfileBlock.length - 1 &&
          this.soilProfileBlock[this.soilProfileBlock.length - 2]
        ) {
          this.setNestedParameter({
            value: null,
            item: item,
            parameter: "x_end",
          });
          this.setNestedParameter({
            value: value,
            item: this.soilProfileBlock[this.soilProfileBlock.length - 2],
            parameter: "x_end",
          });
        } else if (
          this.soilProfileBlock[newIndex - 1] &&
          this.soilProfileBlock[newIndex + 1]
        ) {
          this.setNestedParameter({
            value: value,
            item: this.soilProfileBlock[newIndex - 1],
            parameter: "x_end",
          });
          this.setNestedParameter({
            value: value,
            item: this.soilProfileBlock[newIndex + 1],
            parameter: "x_start",
          });
        }
      }
    },
    setStartParameter(index, value, item) {
      if (this.soilProfileBlock[index - 1]) {
        this.setNestedParameter({
          value: value,
          item: this.soilProfileBlock[index - 1],
          parameter: "x_end",
        });
      }
      this.setNestedParameter({
        value: value,
        item: item,
        parameter: "x_start",
      });
    },
    setEndParameter(index, value, item) {
      if (this.soilProfileBlock[index + 1]) {
        this.setNestedParameter({
          value: value,
          item: this.soilProfileBlock[index + 1],
          parameter: "x_start",
        });
      }
      this.setNestedParameter({
        value: value,
        item: item,
        parameter: "x_end",
      });
    },
  },
};
</script>
